<script setup>
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
moment.locale("id");
</script>
<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div
          class="bg-red-ss rounded-top-10 w-100 border border-1 pt-2"
          style="min-height: 5vh"
        >
          <div style="color: #28293d" class="px-3 pb-2">
            <button @click="$router.back()" class="btn">
              <font-awesome-icon
                icon="fa-solid fa-arrow-left"
                style="color: #28293d"
              />
            </button>
            NC
          </div>
          <div
            class="bg-white rounded-top-10 w-100 border border-1 shadow-sm p-2"
            style="min-height: 60vh"
          >
            <div class="container-fluid p-4">
              <div class="evaluation-table-container">
                <table class="evaluation-form-table">
                  <tbody>
                    <tr class="evaluation-table-heading">
                      <td colspan="2" style="background-color: #f8d7da">
                        Form Penilaian Calon Penanggung Jawab
                      </td>
                    </tr>
                    <tr>
                      <td>Nama Calon PJO</td>
                      <td>
                        {{
                          dataPJO !== null && dataPJO !== undefined
                            ? dataPJO.nama !== undefined &&
                              dataPJO.nama !== null
                              ? dataPJO.nama
                              : "-"
                            : "-"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>Perusahaan</td>
                      <td>
                        {{
                          capitalized(
                            dataPJO !== null && dataPJO !== undefined
                              ? dataPJO.perusahaan !== undefined &&
                                dataPJO.perusahaan !== null
                                ? dataPJO.perusahaan
                                : "-"
                              : "-",
                          )
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>Tanggal Presentasi</td>
                      <td>
                        {{
                          dataPJO !== null && dataPJO !== undefined
                            ? dataPJO.tanggalPresentasi !== undefined &&
                              dataPJO.tanggalPresentasi !== null
                              ? moment(dataPJO.tanggalPresentasi).format("LL")
                              : "-"
                            : "-"
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <a
                v-if="dataNC.length > 0"
                class="btn mt-3"
                style="background-color: #a0eeca"
                @click="getNcData()"
                ><font-awesome-icon icon="fa-solid fa-download" />&nbsp;Download
                Data NC</a
              >
              <table
                class="table w-100 rounded table-borderless mt-2"
                style="overflow: hidden; font-family: 'Inter-Medium', serif"
              >
                <thead
                  style="
                    font-family: 'Inter-Medium', serif;
                    line-height: 24px;
                    color: #28293d;
                  "
                >
                  <tr style="max-height: 5vh">
                    <th class="p-2 text-nowrap fs-5" style="width: 15%">
                      <b>Total NC : {{ totalData - totalDataInfo }}</b>
                    </th>
                    <th class="p-2 text-nowrap fs-5" style="width: 25%">
                      <b>Total NC Approved : {{ totalDataApproved }}</b>
                    </th>
                    <th class="p-2 text-nowrap fs-5" style="width: 20%">
                      <b>Total NC Revision : {{ totalDataRevision }}</b>
                    </th>
                    <th class="p-2 text-nowrap fs-5" style="width: 40%">
                      <b
                        >Persentasi NC Approved :
                        {{
                          (
                            (totalDataApproved / (totalData - totalDataInfo)) *
                            100
                          ).toFixed(0)
                        }}%</b
                      >
                    </th>
                  </tr>
                </thead>
              </table>
              <div class="mt-8 rounded-lg shadow-md overflow-x-auto w-full">
                <v-data-table-server
                  v-model:items-per-page="dataTable.pagination.itemsPerPage"
                  :items-per-page-options="[5, 10, 25, 50, 100]"
                  :headers="
                    type == 3
                      ? dataTable.headers.filter((header) => header.title != '')
                      : dataTable.headers
                  "
                  :items="dataTable.items"
                  :items-length="dataTable.pagination.totalItems"
                  @update:options="getListNC"
                >
                  <template v-slot:item="{ item, index }">
                    <tr
                      class="border-b border-gray-950 h-16"
                      :class="{ 'bg-gray-50': index % 2 !== 0 }"
                    >
                      <td class="text-center">{{ getIndex(index) }}</td>
                      <td>
                        {{
                          item.jenisAspek != null
                            ? capitalized(item?.jenisAspek)
                            : "Administrasi"
                        }}
                        -
                        {{ item.aspek != null ? item.aspek : "Administrasi" }}
                        - {{ item.kriteriaPenilaian }}
                      </td>
                      <td>
                        {{ item.catatan }}<br />
                        <a
                          class="text-danger pointer fs-10 fw-bold"
                          style="text-decoration: none"
                          v-if="
                            userData.role.includes('ADMIN') ||
                            userData.id == item.createdBy
                          "
                          data-bs-toggle="modal"
                          data-bs-target="#modalEditCatatan"
                          @click="setIndexCatatan(index)"
                          :hidden="item.status == 'accept'"
                        >
                          Edit Catatan
                        </a>
                      </td>
                      <td>
                        {{
                          item.namaKustodian == null ? "-" : item.namaKustodian
                        }}
                      </td>
                      <td>
                        <p>
                          {{
                            item.dueDate != null
                              ? moment(item.dueDate).format("DD/MM/YYYY")
                              : "-"
                          }}<br />
                          <a
                            class="text-danger pointer fs-10 fw-bold"
                            style="text-decoration: none"
                            v-if="userData.role.includes('ADMIN')"
                            data-bs-toggle="modal"
                            data-bs-target="#modalDueDate"
                            @click="setIndexBatasWaktu(index)"
                            :hidden="item.status == 'accept'"
                          >
                            Edit Batas Waktu
                          </a>
                        </p>
                      </td>
                      <td>
                        <div v-if="item.status == 'open'">
                          <span
                            class="badge"
                            style="background-color: #b99b22; color: #f2f0f0"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-circle"
                              style="
                                font-size: 0.5em;
                                margin-bottom: 0.25em;
                                color: #f2f0f0;
                              "
                            />
                            Opened</span
                          >
                        </div>
                        <div
                          v-if="item.status == 'review' && item.assets == null"
                        >
                          <span
                            class="badge"
                            style="background-color: #b99b22; color: #f2f0f0"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-circle"
                              style="
                                font-size: 0.5em;
                                margin-bottom: 0.25em;
                                color: #f2f0f0;
                              "
                            />
                            Opened</span
                          >
                        </div>
                        <div
                          v-if="item.status == 'review' && item.assets != null"
                        >
                          <span
                            class="badge"
                            style="background-color: #ec8a29; color: #f2f0f0"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-circle"
                              style="
                                font-size: 0.5em;
                                margin-bottom: 0.25em;
                                color: #f2f0f0;
                              "
                            />
                            Under Review</span
                          >
                        </div>
                        <div v-else-if="item.status == 'accept'">
                          <span
                            class="badge"
                            style="background-color: #02a12d; color: #f2f0f0"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-circle"
                              style="
                                font-size: 0.5em;
                                margin-bottom: 0.25em;
                                color: #f2f0f0;
                              "
                            />
                            Approved</span
                          >
                        </div>
                        <div v-else-if="item.status == 'reject'">
                          <span
                            class="badge"
                            style="background-color: #df4d20; color: #f2f0f0"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-circle"
                              style="
                                font-size: 0.5em;
                                margin-bottom: 0.25em;
                                color: #f2f0f0;
                              "
                            />
                            Need Revision</span
                          >
                        </div>
                        <div v-else-if="item.status == 'info'">
                          <span
                            class="badge"
                            style="background-color: #209cdf; color: #f2f0f0"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-circle"
                              style="
                                font-size: 0.5em;
                                margin-bottom: 0.25em;
                                color: #f2f0f0;
                              "
                            />
                            Information</span
                          >
                        </div>
                      </td>
                      <td>
                        <template
                          v-if="
                            item.assets != null &&
                            Array.isArray(JSON.parse(item.assets))
                          "
                        >
                          <ul>
                            <li
                              v-for="(asse, idx) in JSON.parse(item.assets)"
                              :key="idx"
                            >
                              <a
                                class="text-danger pointer"
                                @click="viewFile(asse.filename)"
                                >{{ asse.actual_name }}</a
                              >
                            </li>
                          </ul>
                        </template>
                        <template
                          v-else-if="
                            item.assets != null &&
                            !Array.isArray(JSON.parse(item.assets))
                          "
                        >
                          <a
                            class="text-danger pointer"
                            @click="viewFile(JSON.parse(item.assets).filename)"
                            >{{ JSON.parse(item.assets).actual_name }}</a
                          >
                        </template>
                        <template v-if="item.status == 'reject'">
                          <p class="fs-8 fw-bold" style="text-decoration: none">
                            Alasan tolak : {{ item.rejectReason }}
                          </p>
                        </template>
                      </td>
                      <td
                        style="display: flex; justify-content: center"
                        :hidden="type == 3"
                      >
                        <button
                          type="button"
                          class="btn btn-outline-success color-approve"
                          @click="clickApprove(index)"
                          v-if="
                            userData.role.includes('ADMIN') ||
                            userData.id == item.createdBy
                          "
                          :hidden="
                            item.status == 'accept' ||
                            item.status == 'reject' ||
                            item.status == 'info' ||
                            (item.status == 'review' && item.assets == null)
                          "
                        >
                          <font-awesome-icon icon="fa-solid fa-circle-check" />
                        </button>
                        &nbsp;
                        <button
                          type="button"
                          class="btn btn-outline-danger color-reject"
                          @click="clickReject(index)"
                          data-bs-toggle="modal"
                          data-bs-target="#modalCatatanTolakNC"
                          v-if="
                            userData.role.includes('ADMIN') ||
                            userData.id == item.createdBy
                          "
                          :hidden="
                            item.status == 'accept' ||
                            item.status == 'reject' ||
                            item.status == 'info' ||
                            (item.status == 'review' && item.assets == null)
                          "
                        >
                          <font-awesome-icon icon="fa-solid fa-circle-xmark" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-info color-info"
                          @click="clickInfo(index)"
                          v-if="
                            userData.role.includes('ADMIN') ||
                            userData.id == item.createdBy
                          "
                          :hidden="
                            item.status == 'accept' || item.status == 'reject'
                          "
                        >
                          <font-awesome-icon icon="fa-solid fa-circle-info" />
                        </button>
                      </td>
                    </tr>
                  </template>
                </v-data-table-server>
                <div
                  class="d-flex align-items-center justify-content-end p-2"
                  v-if="statusSio == 6 && userData.role.includes('ADMIN')"
                >
                  <button
                    class="btn btn_cari mt-3"
                    :disabled="!conditionButton"
                    @click="clickContinue(sioID, type)"
                  >
                    Lanjutkan Penerbitan CoC
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>
  <div
    class="modal fade"
    id="modalDueDate"
    tabindex="-1"
    aria-labelledby="modalDueDateLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Update Batas Waktu NC</h5>
          <!-- <p>Silahkan Upload berkas anda</p> -->
          <div class="d-flex justify-content-end">
            <button
              ref="closeModalDueDate"
              type="button"
              id="btnClose"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
        </div>
        <div class="modal-body" style="font-family: 'Inter-Regular'">
          <div class="form-group mt-2">
            <label for="tglBatasWaktu" class="form-label fs-6"
              >Tanggal Batas Waktu</label
            >
            <datepicker
              v-model="formBatasWaktu"
              value=""
              name="tglBatasWaktu"
              placeholder="Masukan Tanggal Batas Waktu"
              class="form-control fs-9"
              input-class="fw-bold"
              format="yyyy-MM-dd"
            ></datepicker>
          </div>
        </div>
        <div class="modal-footer border border-0 mt-1">
          <button
            class="btn btn_cari w-100 fs-8 fw-bold"
            @click="setBatasWaktu(idxBatasWaktu)"
          >
            Simpan
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="modalCatatanTolakNC"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Catatan Penolakan NC</h5>
          <!-- <p>Silahkan Upload berkas anda</p> -->
          <div class="d-flex justify-content-end">
            <button
              ref="closeModalReject"
              type="button"
              id="btnCloseReject"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
        </div>
        <div class="modal-body" style="font-family: 'Inter-Regular'">
          <!-- <p>Modal body text goes here.</p> -->
          <p class="text-secondary fs-8">
            Masukkan Catatan Penolakan NC pada kolom dibawah ini
          </p>
          <div class="row">
            <div class="col-md-12">
              <div class="mb-1">
                <label for="file" class="form-label fs-8 fw-bold"
                  >Catatan</label
                >
              </div>
              <textarea
                class="form-control fs-8"
                id="exampleFormControlTextarea1"
                rows="7"
                v-model="rejectReason"
                placeholder="Masukkan catatan mengapa NC ditolak"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer border border-0 mt-1">
          <button
            class="btn btn_cari w-100 fs-8 fw-bold"
            @click="confirmReject(idxUpdateStatus)"
          >
            Simpan
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="modalEditCatatan"
    tabindex="-1"
    aria-labelledby="modalEditCatatanLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Update Catatan NC</h5>
          <!-- <p>Silahkan Upload berkas anda</p> -->
          <div class="d-flex justify-content-end">
            <button
              ref="closeModalEditCatatan"
              type="button"
              id="btnCloseCatatan"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
        </div>
        <div class="modal-body" style="font-family: 'Inter-Regular'">
          <div class="form-group mt-2">
            <div class="row">
              <div class="col-md-12">
                <div class="mb-1">
                  <label for="file" class="form-label fs-8 fw-bold"
                    >Catatan</label
                  >
                </div>
                <textarea
                  v-model="formCatatan"
                  class="form-control fs-8"
                  id="exampleFormControlTextarea1"
                  rows="7"
                  placeholder="Masukkan catatan"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer border border-0 mt-1">
          <button
            class="btn btn_cari w-100 fs-8 fw-bold"
            @click="setCatatan(idxCatatan)"
          >
            Simpan
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Loading overlay -->
  <div v-if="isLoading" class="loading-overlay">
    <!-- You can customize the loading content here (e.g., a spinner) -->
    <div>
      <img
        src="../../assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
</template>
<style>
section .vuejs3-datepicker__calendar-topbar {
  min-height: auto !important;
}

.vuejs3-datepicker__value {
  font-size: 0.7rem !important;
  border: 0px !important;
  padding: 0px !important;
}

.vuejs3-datepicker__icon svg {
  height: 0.8rem;
}

.vuejs3-datepicker__content {
  font-size: 0.8rem !important;
  margin-left: 0.3rem !important;
  margin-bottom: -1rem !important;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  /* Semi-transparent white overlay */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  /* Make sure it's above other elements on the page */
}

.loading-spinner {
  /* Add your loading spinner styles here */
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  /* animation: spin 1s linear infinite; */
}

/* @keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
} */
</style>
<style scoped>
.ellipsis {
  width: 95%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.color-approve {
  background: #b6f4d5;
  border: none;
}

.color-reject {
  background: #f9d6d6;
  border: none;
  margin-left: 5px;
}

.color-info {
  background: #d6f8f9;
  border: none;
  margin-left: 5px;
}
:deep(thead) {
  background-color: #fecaca;
}
</style>

<script>
// import router from "../router";
// import SidebarComponent from "@/components/SideBar.vue";
import GlobalDataMixin from "../../GlobalDataMixin";
import {
  API_BASE_URL,
  CMS_GET_PENILAIANDETAIL,
  CMS_GET_NC_LIST,
  CMS_SET_NC,
  // CMS_DOWNLOAD,
  CMS_GET_SIOID,
  CMS_SET_STATUS_SIO,
  CMS_VIEW_DOCUMENT,
  CMS_GET_DATA_NC,
} from "@/constants";
import axios from "axios";
import Datepicker from "vuejs3-datepicker";

import Swal from "sweetalert2";
import { capitalized } from "@/utilities/helpers";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import {
  CreateDataTableObject,
  SetDataTableResponse,
} from "@/utilities/DataTableHelpers";

// import {
//   API_BASE_URL,

// } from "../../constants.js"

// const max_file_size = 5; // MB
const url_get_penilaiandetail = API_BASE_URL + CMS_GET_PENILAIANDETAIL;
const url_get_list_nc = API_BASE_URL + CMS_GET_NC_LIST;
const url_set_nc = API_BASE_URL + CMS_SET_NC;
// const url_download = API_BASE_URL + CMS_DOWNLOAD
const url_get_sioid = API_BASE_URL + CMS_GET_SIOID;
const url_set_sio_status = API_BASE_URL + CMS_SET_STATUS_SIO;
const url_view_document = API_BASE_URL + CMS_VIEW_DOCUMENT;
const url_get_nc_data = API_BASE_URL + CMS_GET_DATA_NC;

export default {
  mixins: [GlobalDataMixin],
  name: "NCPage",
  components: { DefaultLayout, Datepicker },
  data() {
    return {
      dataTable: CreateDataTableObject([
        { title: "No.", align: "start", sortable: false, width: "3%" },
        {
          title: "Aspek & Kriteria Penilaian",
          align: "start",
          sortable: false,
          width: "20%",
        },
        {
          title: "Catatan",
          align: "start",
          sortable: false,
          width: "19%",
        },
        { title: "Evaluator", align: "start", sortable: false, width: "12.5%" },
        { title: "Batas Waktu", align: "start", sortable: false, width: "8%" },
        { title: "Status", align: "center", sortable: false, width: "7.5%" },
        { title: "File", align: "center", sortable: false, width: "10%" },
        { title: "", align: "center", sortable: false, width: "auto" },
      ]),
      isLoading: true,
      kontraktorId: null,
      sioID: null,
      statusSio: null,
      type: null,
      currentPage: 1,
      perPage: 5,
      totalData: 0,
      totalDataApproved: 0,
      totalDataInfo: 0,
      totalDataRevision: 0,
      rejectReason: null,
      dataPJO: {
        nama: null,
        perusahaan: null,
        tanggalPresentasi: null,
      },
      formBatasWaktu: null,
      formCatatan: null,
      idxBatasWaktu: null,
      idxUpdateStatus: null,
      idxCatatan: null,
      idPenjadwalan: null,
      kustodians: [],
      dataNC: [],
    };
  },
  mounted() {
    this.idPenjadwalan = this.$route.params.idpenjadwalan;
    this.kontraktorId = this.$route.params.kontraktorId;
    this.getPenilaianDetail();
    this.getListNC();
    this.getSioID(this.kontraktorId);
  },
  computed: {
    conditionButton() {
      return (
        this.totalDataApproved / (this.totalData - this.totalDataInfo) >= 0.9
      );
    },
  },
  methods: {
    capitalized(name) {
      if (name != null) {
        return name
            .toLowerCase()
            .replace(/\b\w/g, char => char.toUpperCase());
      }
      return name;
    },
    resetPaginasi() {
      this.dataNC = [];
      this.perPage = 5;
      this.currentPage = 1;
      this.totalData = 0;
    },
    changePage(num) {
      let cp = this.currentPage + num;
      if (
        !(num == -1 && this.currentPage == 1) &&
        cp * this.perPage <= this.totalData + (this.perPage - 1)
      ) {
        this.currentPage = this.currentPage + num;
        this.getListNC();
      }
    },
    getIndex(index) {
      return index + (this.currentPage - 1) * this.perPage + 1;
    },
    getPenilaianDetail() {
      let bodyJson = {
        idPenjadwalan: this.idPenjadwalan,
        jenis: "administrasi",
      };

      axios
        .post(url_get_penilaiandetail, bodyJson, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          console.log("response getPenilaianDetail : ", response);
          if (response.data !== undefined && response.data !== null) {
            let dt = response.data;
            this.dataPJO.nama = dt.pjo;
            this.dataPJO.perusahaan = dt.perusahaan;
            this.dataPJO.tanggalPresentasi = dt.schedule;
            this.statusSio = dt.statusSio;
            this.kustodians = dt.kustodians;
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.log("error getPenilaianDetail : ", error);
          alert("error getPenilaianDetail : ", error);
        })
        .then(() => {});
    },
    getListNC({ page, itemsPerPage } = {}) {
      if (page) {
        this.currentPage = page;
      }
      if (itemsPerPage) {
        this.perPage = itemsPerPage;
      }

      if (!this.idPenjadwalan) {
        // this.isLoading = false;
        return;
      }

      let bodyJson = {
        idPenjadwalan: this.idPenjadwalan,
        role: "isafe",
        page: this.currentPage,
        perPage: this.perPage,
      };
      this.isLoading = true;
      axios
        .post(url_get_list_nc, bodyJson, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          let result = {};
          result.data = response.data.data;
          result.total_data = response.data.totalData;
          result.total_per_page = this.perPage;
          result.current_page = this.currentPage;
          this.dataTable = SetDataTableResponse(this.dataTable, result);

          console.log("response getListNC : ", response);
          this.dataNC = response.data.data;
          this.totalData = response.data.totalData;
          this.totalDataApproved = response.data.totalDataApproved;
          this.totalDataInfo = response.data.totalInfo;
          this.totalDataRevision = response.data.totalRevision;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Terjadi kesalahan!",
          });
        })
        .then(() => {});
    },
    setIndexBatasWaktu(index) {
      this.idxBatasWaktu = index;
      this.formBatasWaktu = null;
      if (this.dataNC[index].dueDate != null) {
        this.formBatasWaktu = new Date(this.dataNC[index].dueDate);
      }
    },
    setIndexCatatan(index) {
      this.idxCatatan = index;
      this.formCatatan = null;
      if (this.dataNC[index].catatan != null) {
        this.formCatatan = this.dataNC[index].catatan;
      }
    },
    setCatatan(index) {
      // sementara
      if (this.formCatatan != null && this.formCatatan != "") {
        this.closeModalCatatan();
        this.isLoading = true;
        let catatan = this.formCatatan;
        let bodyJson = {
          updatedBy: this.userData.id,
          id: this.dataNC[index].idNc,
          catatan: catatan,
        };
        axios
          .post(url_set_nc, bodyJson, {
            headers: {
              role: "isafe",
              Authorization: "Bearer " + this.userData.token,
              accept: "application/json",
            },
          })
          .then((response) => {
            console.log("response setCatatan : ", response);
            this.alertSuksesSetBatasWaktu();
          })
          .catch((error) => {
            this.isLoading = false;
            console.log("error setCatatan : ", error);
          })
          .then(() => {});
      } else {
        alert("Tanggal Batas Waktu harus diisi !");
      }
    },
    setBatasWaktu(index) {
      // sementara
      if (this.formBatasWaktu != null && this.formBatasWaktu != "") {
        this.closeModalBatasWaktu();
        this.isLoading = true;
        console.log(index);
        let duedate = moment(this.formBatasWaktu).format("YYYY-MM-DD");
        let bodyJson = {
          // "status": 'open',
          // "assets": null,
          updatedBy: this.userData.id,
          id: this.dataNC[index].idNc,
          dueDate: duedate,
          // "rejectReason": null,
        };
        axios
          .post(url_set_nc, bodyJson, {
            headers: {
              role: "isafe",
              Authorization: "Bearer " + this.userData.token,
              accept: "application/json",
            },
          })
          .then((response) => {
            console.log("response setBatasWaktu : ", response);
            // this.dataNC = response.data.data;
            this.alertSuksesSetBatasWaktu();
          })
          .catch((error) => {
            this.isLoading = false;
            console.log("error setBatasWaktu : ", error);
            alert("error setBatasWaktu : ", error);
          })
          .then(() => {});
      } else {
        alert("Tanggal Batas Waktu harus diisi !");
      }
    },

    closeModalBatasWaktu() {
      document.getElementById("btnClose").click();
    },
    closeModalReject() {
      document.getElementById("btnCloseReject").click();
    },
    closeModalCatatan() {
      document.getElementById("btnCloseCatatan").click();
    },
    alertSuksesSetBatasWaktu() {
      // this.isLoading = false
      Swal.fire({
        title: "Update Data NC",
        text: "Batas Waktu NC berhasil disimpan!",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then(() => {
        // this.$router.back()
        // window.location.reload()

        this.getListNC();
      });
    },
    updateStatusNC(status, index, reason) {
      this.isLoading = true;
      console.log(index);
      // let duedate = moment(this.formBatasWaktu).format('YYYY-MM-DD')
      let bodyJson = {
        status: status,
        // "assets": null,
        updatedBy: this.userData.id,
        id: this.dataNC[index].idNc,
        // "dueDate": duedate,
        rejectReason: reason,
      };
      axios
        .post(url_set_nc, bodyJson, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          console.log("response updateStatusNC : ", response);
          // this.dataNC = response.data.data;
          if (status == "accept") {
            this.alertSuksesApprove();
          } else if (status == "info") {
            this.alertSuksesInfo();
          } else {
            this.alertSuksesReject();
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.log("error updateStatusNC : ", error);
          alert("error updateStatusNC : ", error);
        })
        .then(() => {});
    },

    clickApprove(index) {
      this.idxUpdateStatus = index;
      this.confirmApprove(index);
    },
    clickReject(index) {
      this.idxUpdateStatus = index;
    },
    clickInfo(index) {
      this.idxUpdateStatus = index;
      this.confirmInfo(index);
    },
    confirmApprove(index) {
      Swal.fire({
        title: "Update Data NC",
        text: "Apakah anda yakin untuk menyetujui perbaikan NC berikut ?",
        icon: "confirmation",
        showCancelButton: true,
        showConfirmButton: true,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.updateStatusNC("accept", index);
        }
      });
    },
    confirmReject(index) {
      if (this.rejectReason != null && this.rejectReason != "") {
        Swal.fire({
          title: "Update Data NC",
          text: "Apakah anda yakin untuk menolak perbaikan NC berikut ?",
          icon: "confirmation",
          showCancelButton: true,
          showConfirmButton: true,
          showClass: {
            popup: "animate__animated animate__fadeInDown",
          },
          hideClass: {
            popup: "animate__animated animate__fadeOutUp",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            this.updateStatusNC("reject", index, this.rejectReason);
          }
        });
      } else {
        alert("Catatan Penolakan NC belum diisi!");
      }
    },
    confirmInfo(index) {
      Swal.fire({
        title: "Update Data NC",
        text: "Apakah anda yakin untuk merubah data NC berikut ?",
        icon: "confirmation",
        showCancelButton: true,
        showConfirmButton: true,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.updateStatusNC("info", index);
        }
      });
    },
    alertSuksesApprove() {
      // this.isLoading = false
      Swal.fire({
        title: "Update Data NC",
        text: "Pengajuan NC berhasil disetujui!",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then(() => {
        // this.$router.back()
        // window.location.reload()

        this.getListNC();
      });
    },
    alertSuksesReject() {
      // this.isLoading = false
      Swal.fire({
        title: "Update Data NC",
        text: "Pengajuan NC berhasil ditolak!",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then(() => {
        // this.$router.back()
        // window.location.reload()
        this.closeModalReject();
        this.getListNC();
      });
    },
    alertSuksesInfo() {
      // this.isLoading = false
      Swal.fire({
        title: "Update Data NC",
        text: "NC berhasil diubah menjadi info!",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then(() => {
        // this.$router.back()
        // window.location.reload()

        this.getListNC();
      });
    },
    confirmEdit(index) {
      Swal.fire({
        title: "Update Data Catatan NC",
        text: "Apakah anda yakin untuk merubah catatan NC berikut ?",
        icon: "confirmation",
        showCancelButton: true,
        showConfirmButton: true,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.updateStatusNC("accept", index);
        }
      });
    },
    viewFile(fileName) {
      window.open(url_view_document + fileName, "_blank");
    },
    getSioID(id) {
      axios
        .get(url_get_sioid + id, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          let dt = null;
          dt = response.data.data;
          if (dt != null) {
            this.statusSio = dt.status;
            this.sioID = dt.id;
            this.type = dt.type;
          }
          // this.isLoading = false;
        })
        .catch((error) => {
          console.error("Error fetching data getSioID :", error.message);
        });
    },
    clickContinue(sioID, type) {
      Swal.fire({
        title: "Konfirmasi",
        text: "Apakah Anda yakin akan simpan data ini ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#1db61d",
        cancelButtonColor: "#d6303e",
        confirmButtonText: "Simpan",
        cancelButtonText: "Batal",
      }).then((result) => {
        if (result.isConfirmed) {
          this.updateStatusSIO(sioID, type);
        }
      });
    },
    updateStatusSIO(sioId, type) {
      this.isLoading = true;
      // let duedate = moment(this.formBatasWaktu).format('YYYY-MM-DD')
      let bodyJson = {
        status: 5,
        id: sioId,
        type: type,
      };
      axios
        .post(url_set_sio_status, bodyJson, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          console.log("response update status sio : ", response);
          // this.dataNC = response.data.data;
          this.alertSuksesContinue();
        })
        .catch((error) => {
          this.isLoading = false;
          console.log("error updateStatusNC : ", error);
        })
        .then(() => {});
    },
    alertSuksesContinue() {
      // this.isLoading = false
      Swal.fire({
        title: "Data NC",
        text: "NC berhasil disetujui!",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then(() => {
        this.$router.back();
      });
    },
    getNcData() {
      console.log("url nya = ", url_get_nc_data + this.idPenjadwalan);
      window.open(url_get_nc_data + this.idPenjadwalan, "_blank");
    },
  },
};
</script>
